import {Button, Checkbox, Input} from 'antd';
import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {AppLoader, Header} from '../../../components';
import useQuery from '../../../hooks/useQuery';
import {updateCompanyWaiverSigned} from '../../../redux/actions';
import {IMAGE_URL} from '../../../utility/constants';
import {getUrlExtension, showToast} from '../../../utility/helperFunctions';
import {getPublicCompanyWaiverDetails, updateWaiverSignedApi} from '../Waiver/utils'

export default function WaiverPreview() {
  const publicWaiverKey = useQuery().get('key'); //! /public-waiver?key=..
  console.log('publicWaiverKey', publicWaiverKey);

  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const isPreview = useMemo(() => {
      const previewValue = (queryParams.get('preview') || '').trim().toLowerCase();
      return previewValue === 'yes' || previewValue === 'true' || previewValue === '1';
  }, [queryParams]);
  const previewType = useMemo(() => (queryParams.get('type') || '').trim().toLowerCase(), [queryParams]);
  const companyId = useMemo(() => (queryParams.get('companyId') || '').trim(), [queryParams]);
  console.log('companyId', companyId);
  const isWaiverAcknowledgementPreview = useMemo(() => isPreview && previewType === 'waiveracknowledgement', [isPreview, previewType]);

  const dispatch = useDispatch();
  const history = useHistory();
  const companyData = useSelector(state => state.auth?.companyData);
  const publicClassDetails = useSelector(state => state.publicUser);
  const [loading, setLoading] = useState(!companyData);
  const [waiverState, setWaiverState] = useState({
    url: companyData?.waiver_url ? IMAGE_URL + companyData.waiver_url : '',
    companyName: companyData?.name,
    isChecked: false,
    isChecked18Plus: false,
    name: '',
    loading: false,
    isWaiverSigned: companyData?.waiver_signed,
  });
  const [isAndroidDevice, setIsAndroidDevice] = useState(true);
  const [shouldShowWaiverViewer, setShouldShowWaiverViewer] = useState(true);
  const [hasViewedWaiver, setHasViewedWaiver] = useState(false);
  const waiverViewedStorageKey = useMemo(() => {
    if (publicWaiverKey) {
      return `waiverViewed:public:${publicWaiverKey}`;
    }
    if (companyId) {
      return `waiverViewed:company:${companyId}`;
    }
    return 'waiverViewed';
  }, [companyId]);

  const waiverExtension = getUrlExtension(waiverState.url);
  const waiverViewerUrl = waiverState?.url
    ? `${waiverExtension === 'docx' ? 'https://view.officeapps.live.com/op/embed.aspx?src=' : ''}${
        waiverState?.url
      }`
    : '';

  const handleOpenWaiver = event => {
    event?.preventDefault?.();
    if (!waiverViewerUrl) {
      return;
    }
    // if (typeof window !== 'undefined') {
    //   window.open(waiverViewerUrl, '_blank', 'noopener,noreferrer');
    // }
    setShouldShowWaiverViewer(true);
    setHasViewedWaiver(true);
    if (typeof window !== 'undefined') {
      try {
        window.sessionStorage?.setItem(waiverViewedStorageKey, 'true');
      } catch (error) {
        console.error('Unable to persist waiver viewed flag', error);
      }
    }
    location.href = waiverViewerUrl;
  };

  useEffect(() => {
    //! if company got changed, update context
    setWaiverState({
      url: companyData?.waiver_url ? IMAGE_URL + companyData.waiver_url : '',
      companyName: companyData?.name,
      isChecked: false,
      name: '',
      loading: false,
      isWaiverSigned: companyData?.waiver_signed,
    });
  }, [companyData?.id, companyData?.waiver_url]);

  useEffect(() => {
    const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent?.toLowerCase?.() : '';
    const isAndroid = userAgent?.includes?.('android');
    setIsAndroidDevice(Boolean(isAndroid));
    setShouldShowWaiverViewer(!isAndroid);
    if (typeof window !== 'undefined') {
      try {
        const storedValue = window.sessionStorage?.getItem(waiverViewedStorageKey);
        if (storedValue === 'true') {
          setHasViewedWaiver(true);
          return;
        }
      } catch (error) {
        console.error('Unable to read waiver viewed flag', error);
      }
    }
    setHasViewedWaiver(!isAndroid);
  }, [waiverViewedStorageKey]);

  useEffect(async () => {
  
      const res = await getPublicCompanyWaiverDetails(companyId);
      if (res?.data?.success) {
        setWaiverState({
          url: res?.data?.waiver_url,
          companyName: res?.data?.company_name,
          name: res?.data?.waiver_signed_details?.signerName,
          isWaiverSigned: res?.data?.waiver_signed_details?.signerName,
        });
      }
      setLoading(false);
    
  }, []);

  const _handleWaiverSigned = async () => {
    if (isAndroidDevice && !hasViewedWaiver) {
      showToast.warning('Please view the waiver at least once before acknowledging.');
      return;
    }
    setWaiverState(p => ({
      ...p,
      loading: true,
    }));
    const res = await updateWaiverSignedApi({
      signed_name: waiverState?.name,
      publicWaiverKey,
    });
    showToast.success(res?.data?.message);
    if (publicWaiverKey) {
      setWaiverState(p => ({
        ...p,
        loading: false,
        isWaiverSigned: true,
      }));
      return;
    }
    dispatch(updateCompanyWaiverSigned());
    _nav();
  };

  const _nav = () => {
    //! if user is coming from public booking link
    history.replace(publicClassDetails?.classId ? '/class-booking' : '/dashboard');
  };
console.log('waiverState', waiverState);
  if (loading) {
    return <AppLoader />;
  }
  return (
    <>
      {companyData && <Header />}
      <div className="main-content no-left-margin">
        <div className="page-content">
          <div className="container waiver-preview-container">
            {waiverState?.url && isAndroidDevice && waiverViewerUrl &&(
              <Button
                type="link"
                className="px-0"
                onClick={handleOpenWaiver}
              >
                Tap here to view the waiver
              </Button>
            )}
            <p className="font-size-20">
              Prior to booking a service with{' '}
              <span className="font-weight-bold">{waiverState?.companyName}</span>, you must review
              the waiver and policies included below and acknowledge that you have reviewed them and
              agree to their terms and conditions.
            </p>
            
            {waiverState?.url && (!isAndroidDevice) && (
              <div className="card shadow">
                <iframe
                  src={waiverViewerUrl}
                  width="100%"
                  height="700px"
                  // onLoad={() => console.log("iframe loaded")}
                />
              </div>
            )}

            {waiverState?.isWaiverSigned ? (
              <div>
                <p className="text-success mt-2">
                  {`Waiver already signed${!publicWaiverKey ? ', please continue booking' : ''}!`}
                </p>
                {waiverState?.name && <p>Signed Name: {waiverState?.name}</p>}
                <button
                  className="btn btn-primary waves-effect waves-light _theme-btn mb-2 width-180"
                  type="submit"
                  onClick={_nav}
                >
                  Go To Dashboard
                </button>
              </div>
            ) : (
              <>
                <div className="font-size-18 waiver-checkbox">
                  <Checkbox
                    checked={waiverState?.isChecked}
                    onChange={e =>
                      setWaiverState(p => ({
                        ...p,
                        isChecked: e.target.checked,
                      }))
                    }
                    disabled={isWaiverAcknowledgementPreview}
                  >
                    I hereby acknowledge that I have received and read the waiver and policies for{' '}
                    <span className="font-weight-bold">{companyData?.name}</span> and agree to their
                    terms and conditions.
                  </Checkbox>
                </div>
                <div className="font-size-18 waiver-checkbox mt-3">
                  <Checkbox
                    checked={waiverState?.isChecked18Plus}
                    onChange={e =>
                      setWaiverState(p => ({
                        ...p,
                        isChecked18Plus: e.target.checked,
                      }))
                    }
                     disabled={isWaiverAcknowledgementPreview}
                  >
                    If you are under the age of 18, your parent or legal guardian must consent to
                    this agreement and affirm that they accept the agreement on your behalf and bear
                    responsibility for your use. If you are accepting this agreement on behalf of
                    someone else, you confirm that you have the legal authority to bind that person
                    or entity to this agreement.
                  </Checkbox>
                </div>
                <div className="row mt-4 align-items-center justify-content-start waiver-signature-row">
                  <div className="col-md-4 mb-3 mb-md-0">
                    <Input
                      placeholder="Full Name"
                      onChange={e => setWaiverState(p => ({...p, name: e.target.value}))}
                      value={waiverState?.name}
                      disabled={isWaiverAcknowledgementPreview}
                    />
                  </div>
                  <div className="col-md-auto d-grid">
                    <Button
                      type="primary"
                      size="small"
                      loading={waiverState?.loading}
                      className="btn btn-primary waves-effect waves-light _theme-btn mb-2 ant-md-btn"
                      onClick={_handleWaiverSigned}
                      disabled={
                        !waiverState?.isChecked ||
                        !waiverState?.isChecked18Plus ||
                        !waiverState?.name 
                        || isWaiverAcknowledgementPreview
                      }
                    >
                      Acknowledge
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
